import {useMutation} from "@tanstack/react-query";

import {createMaterialMutationOptions} from "./create-material.mutation-options";

export function useCreateMaterial() {
  return useMutation(createMaterialMutationOptions());
}
